import { ReactNode } from "react";
import classNames from "classnames";
import { Grid } from "capitalrx-components-2.0/lib/layout";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import styled, { css } from "styled-components";

/** The `MainFormSection` component properties. */
export interface MainFormSectionProps {
  readonly sectionTitle?: string;
  readonly showRequire?: boolean;
  readonly theme?: string;
  readonly removeSectionTitle?: boolean;
  readonly removeSectionTitleWrapper?: boolean;
  readonly bordered?: boolean;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The section title. */
const SectionTitle = styled.div<{ $remove: boolean }>`
  width: auto;
  display: inline-block;
  padding: 5px 0;
  margin-bottom: ${({ $remove }) => $remove ? "45px" : "unset"};
  color: ${Color.toString(Color.DarkBlue["500"])};
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
`;

const SectionTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${Color.toString(Color.DarkGrey["500"])};
  margin-bottom: 15px;
`;

const RequiredIndicator = styled.div`
  justify-content: flex-end;

  span {
    color: ${Color.toString(Color.Orange["500"])};
  }
`;

const MainFormSectionContent = styled.div<{ $border: boolean }>`
  ${({ $border }) => $border && css`
    margin-bottom: 30px;
    border-radius: 3px;
    border: 1px solid ${Color.toString(Color.LightGrey["300"])};
    padding: 25px 20px 0px 20px;
  `}

  &>div {
    margin-top: 10px;
  }
`;

/**
 * The main form section component.
 * @deprecated Please move away from this and build your own equivalent using updated components.
 */
export const MainFormSection = (props: MainFormSectionProps): ReactNode => {
  const {
    children,
    sectionTitle,
    theme = "",
    showRequire = false,
    removeSectionTitle = false,
    removeSectionTitleWrapper = false,
    bordered = false,
  } = props;

  return (
    <>
      <Grid.Span columns={12}>
        <SectionTitleWrapper className={classNames({ [theme]: !!theme && !removeSectionTitleWrapper }, "wrapper-main")}>
          <SectionTitle $remove={removeSectionTitle}>{sectionTitle}</SectionTitle>
          {showRequire && (
            <RequiredIndicator>
              <span>*</span>=Required Field
            </RequiredIndicator>
          )}
        </SectionTitleWrapper>
      </Grid.Span>
      <div>
        <div>
          <MainFormSectionContent className={classNames({ [theme]: !!theme && !removeSectionTitleWrapper }, "main-form-section")} $border={bordered}>
            <div>{children}</div>
          </MainFormSectionContent>
        </div>
      </div>
    </>
  );
};
